import wx from './jweixin1.6.0.js';
import http from './http'
import utils from './utils'

class WxPay {
	constructor(){
		this.init()
	}
	// appId: 'wxed3c0977b2b75767'  电巢学堂,
	// appId: 'wxab90d9e1f258bb9e'  电巢app,
	init(){
		if(utils.browserChecker.isWx()){
			http.get('user/getShareSign', {
				params: {
					appid: 'wxab90d9e1f258bb9e',
					url: encodeURIComponent(window.location.href.split('#')[0])
				}
			}).then(res => {
				let data = res.data
				wx.config({
					debug: false,
					appId: 'wxab90d9e1f258bb9e',
					timestamp: data.timestamp,
					nonceStr: data.noncestr,
					signature: data.signature,
					jsApiList: ['checkJsApi', 'chooseWXPay']
				})
			})
		}
	}
	// callback
	// success: callback
	pay(payload={}){
		let option = {
			timestamp: payload.timeStamp,
			nonceStr: payload.nonceStr,
			package: payload.package,
			signType: payload.signType,
			paySign: payload.paySign,
		}
		wx.chooseWXPay(option)
	}
}

export default WxPay